import * as Styled from './SubmitPanel.styled';
import { CDN_STATIC_ASSETS } from '../../../../../utils';

type SubmitPanelProps = {
  isSubmitting: boolean;
};

const SubmitPanel = (props: SubmitPanelProps) => {
  const { isSubmitting } = props;

  return (
    <Styled.Content>
      <Styled.SubmitButton type="submit" disabled={isSubmitting}>
        <Styled.Spinner
          isSubmitting={isSubmitting}
          cdnUrl={CDN_STATIC_ASSETS}
        />
        <Styled.ButtonText isSubmitting={isSubmitting}>
          Submit Application
        </Styled.ButtonText>
      </Styled.SubmitButton>
    </Styled.Content>
  );
};

export { SubmitPanel };
